<template>
  <div class="ds-progress-bar" :class="sizeClass">
    <div
      class="ds-progress-bar__indicator"
      :class="colorClass"
      :style="{ width: `${progress * 100}%` }"
    />
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      validator(value) {
        return ['green'].indexOf(value) !== -1;
      },
      default: 'green',
    },
    size: {
      type: String,
      validator(value) {
        return ['', 'small'].indexOf(value) !== -1;
      },
      default: '',
    },
  },
  computed: {
    colorClass() {
      return {
        green: 'ds-progress-bar__indicator--green',
      }[this.color];
    },
    sizeClass() {
      return {
        small: 'ds-progress-bar--small',
      }[this.size];
    },
  },
};
</script>

<style lang="scss">
@use "@sass/design-system/progress-bar";
</style>
